import { BaseApiClient, VoidApiResponse } from "../base";

export interface Reservation {
  unit?: { name: string };
  magicId: string;
  magicToken: string;
  propertyId: string;
}

const BASE_URL = "/api/guest-journey-service/magic";

class MagicApiClient extends BaseApiClient {
  async assignTagToReservation(reservation: Reservation, tagNumber: string, init?: RequestInit) {
    const response = await this.fetchApi(
      BASE_URL + `/${reservation.magicId}/assign-tag/${tagNumber}`,
      {
        ...init,
        method: "POST",
        headers: {
          "sk-magic-token": reservation.magicToken
        }
      }
    );
    return new VoidApiResponse(response).value();
  }
}

export const MagicApi = new MagicApiClient();
